import { render, staticRenderFns } from "./COD_collectionApproval.vue?vue&type=template&id=6fbd79be&"
import script from "./COD_collectionApproval.vue?vue&type=script&lang=js&"
export * from "./COD_collectionApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports